import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import NavigationMenu from './NavigationMenu';

const Header = ({ title, subtitle, showLastUpdated = false }) => {
  const { t } = useLanguage();

  return (
    <header className="text-center mb-8 relative">
      {/* Navigation Menu */}
      <div className="flex justify-end items-center mb-4">
        <NavigationMenu />
      </div>
      
      <h1 className="text-4xl font-bold text-gray-800 dark:text-gray-100 mb-2">
        {title}
      </h1>
      
      {subtitle && (
        <p className="text-gray-600 dark:text-gray-300 mb-2">
          {subtitle}
        </p>
      )}
      
      {showLastUpdated && (
        <div className="flex items-center justify-center text-sm text-gray-600 dark:text-gray-400">
          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <span>{t('app.lastUpdated', { date: '20-Oct-2025' })}</span>
        </div>
      )}
    </header>
  );
};

export default Header;
